<div *ngIf="(global.globalAgencyId==null ||global.globalAgencyId==undefined ||
global.globalAgencyId=='' || global.globalAgencyId=='00000000-0000-0000-0000-000000000000')">
    <div class="row mb-2">
        <div class="col pl-0">
            <div widget class="card border-0 box-shadow">
                <div class="card-body  widget-body pt-2">
                    <div class="text-center text-danger">
                        <label class="font-red"><i class="fa fa-info-circle fa-lg"></i>&nbsp;Select agency to view
                            details</label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div *ngIf="(global.globalAgencyId!=null && global.globalAgencyId!=undefined  &&
global.globalAgencyId!=''&& global.globalAgencyId!='00000000-0000-0000-0000-000000000000')">
    <div class="row mb-2 mt-2">

        <h4 class="mb-2 py-1 font-header-1">Visits</h4>

    </div>
    <!-- Filters -->
    <div class="row mb-3 mt-2">
        <div class="col ">
            <div widget class="card border-0 box-shadow">
                <div class="card-body  widget-body pt-2">
                    <!-- start Date & end date -->
                    <div class="row mt-2">
                        <div class="col-lg-4">
                            <div class="row">
                                <div class="col-lg-4">
                                    <span>Start date</span>
                                </div>

                                <div class="col-lg-7 col-11  ">
                                    <my-date-picker [options]="myDatePickerOptions" placeholder="mm/dd/yyyy"
                                        [selDate]="FromDateFilter"
                                        (inputFieldChanged)="DateFormat($event,'inputchanged','FilterFromDate')"
                                        (dateChanged)="DateFormat($event,'datechanged','FilterFromDate')">
                                    </my-date-picker>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <div class="row">
                                <div class="col-lg-4">
                                    <span>End date</span>
                                </div>
                                <div class="col-lg-7 col-11 ">
                                    <my-date-picker [options]="myDatePickerOptions" placeholder="mm/dd/yyyy"
                                        [selDate]="EndDateFilter"
                                        (inputFieldChanged)="DateFormat($event,'inputchanged','FilterToDate')"
                                        (dateChanged)="DateFormat($event,'datechanged','FilterToDate')">
                                    </my-date-picker>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-4">
                            <div class="row">
                                <div class="col-lg-4">
                                    <span>service</span>
                                </div>
                                <div class="col-lg-8 col-11">
                                    <ng-select [(ngModel)]="EvvtimesheetsendBO.serviceId" [searchable]="true"
                                        [clearable]="true" [items]="serviceList" bindLabel="Value" bindValue="Key">
                                    </ng-select>
                                </div>
                            </div>
                        </div>


                    </div>
                    <!-- CLient & employee  -->
                    <div class="row mt-4">
                        <div class="col-lg-4">
                            <div class="row">
                                <div class="col-lg-4">
                                    <span>Employee</span>
                                </div>
                                <div class="col-lg-7 col-11 ">
                                    <ng-select [searchable]="true" [(ngModel)]="EvvtimesheetsendBO.employeeId"
                                        [clearable]="true" bindLabel="Value" bindValue="Key"
                                        [items]="AllEmployeeDropDownList">
                                    </ng-select>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 ">
                            <div class="row">
                                <div class="col-lg-4">
                                    <span>Client</span>
                                </div>
                                <div class="col-lg-7 col-11 ">
                                    <ng-select [searchable]="true" [(ngModel)]="EvvtimesheetsendBO.clientId"
                                        [clearable]="true" bindLabel="Value" bindValue="Key"
                                        [items]="AllClientDropDownList">
                                    </ng-select>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 ">
                            <div class="row">
                                <div class="col-lg-4">
                                    <span>Visit TypeName </span>
                                </div>
                                <div class="col-lg-7 col-11 ">
                                    <select [(ngModel)]="EvvtimesheetsendBO.visitTypeName" class="form-select">
                                        <option value=""></option>
                                        <option value="MANUAL">MANUAL</option>
                                        <option value="MOBILE">MOBILE</option>
                                    </select>
                                </div>
                            </div>
                        </div>


                    </div>
                    <div class="row mt-4">
                        <div class="col-lg-4">
                            <div class="row">
                                <div class="col-lg-4">
                                    <span>Validate</span>
                                </div>
                                <div class="col-lg-7 col-11 ">
                                    <select [(ngModel)]="EvvtimesheetsendBO.errortype" class="form-select">
                                        <option value=""></option>
                                        <option value="Client Signature">Client Signature</option>
                                        <option value="Employee Signature">Employee Signature</option>
                                        <option value="Activities">Activities</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 ">
                            <div class="row">
                                <div class="col-lg-4">
                                    <span>Visits Status </span>
                                </div>
                                <div class="col-lg-7 col-11 ">
                                    <select [(ngModel)]="EvvtimesheetsendBO.visitProgressStatus" class="form-select">
                                        <option value=""></option>
                                        <option value="Completed">Completed</option>
                                        <option value="InProgress">InProgress</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <div class="row">
                                <div class="col-lg-4">
                                    <label>Validation Status </label>
                                </div>
                                <div class=" col-lg-7 col-11">
                                    <select [(ngModel)]="EvvtimesheetsendBO.evvstatus" class="form-select">
                                        <option value=""></option>
                                        <option value="false">Validate</option>
                                        <option value="true">Ready</option>
                                    </select>
                                </div>
                            </div>

                        </div>

                    </div>

                    <div class="row mt-3">
                        <div class="col-lg-6">
                            <div>
                                <!-- <button class="btn btn-sm" data-bs-target="#UpdateRatetimesheet1"
                                    data-bs-toggle="modal" (click)="clearTax()" >
                                    Re-Calculate Rate</button>&nbsp;&nbsp; -->
                                <button class="btn btn-sm" (click)="EvvTimesheetEmitpage()" *ngIf="fp.visitscreate">Add
                                    Visits</button>&nbsp;&nbsp;
                                <button class="btn btn-sm me-3" data-bs-target="#deleteMultiTimesheet"
                                    data-bs-toggle="modal" [disabled]="!multiDisable">
                                    Delete
                                </button>
                                <button class="btn btn-sm  me-2" *ngIf="VisitSelectedTab=='Active'"
                                    [disabled]="selected_data.length==0 || IsButtonDisable"
                                    (click)="MoveToArchive()">Move to
                                    Archive</button>
                                <button class="btn btn-sm me-2 mb-1" *ngIf="VisitSelectedTab=='Archive'"
                                    [disabled]="selected_data.length==0 || IsButtonDisable"
                                    (click)="MoveToActive()">Move to
                                    Active</button>


                                <button class="btn btn-sm me-2" [disabled]="selected_data.length==0 || IsButtonDisable"
                                    (click)="evvMarkedCheckbox(false)">Approve</button>
                                <button class="btn btn-sm me-2" [disabled]="selected_data.length==0 || IsButtonDisable"
                                    (click)="evvMarkedCheckbox(true)">Unapprove</button>
                            </div>

                        </div>

                        <div class="col-lg-6 text-end">
                            <div>
                                <button type="button" class="btn btn-sm me-3" data-bs-target="#BulkUpdateevv"
                                    data-bs-toggle="modal" (click)="getBulkUpdateActiveAuths()"
                                    *ngIf="global.loginusername=='SUPERADMIN'"
                                    [disabled]="EvvtimesheetsendBO.clientId == '' || EvvtimesheetsendBO.clientId == null || EvvtimesheetsendBO.clientId == undefined || EvvtimesheetsendBO.clientId == '00000000-0000-0000-0000-000000000000'
                                || EvvtimesheetsendBO.employeeId == '' || EvvtimesheetsendBO.employeeId == null || EvvtimesheetsendBO.employeeId == undefined || EvvtimesheetsendBO.employeeId == '00000000-0000-0000-0000-000000000000'
                                || EvvtimesheetsendBO.serviceId == '' || EvvtimesheetsendBO.serviceId == null || EvvtimesheetsendBO.serviceId == undefined || EvvtimesheetsendBO.serviceId == '00000000-0000-0000-0000-000000000000'
                                || FromDateFilter == ''|| FromDateFilter == null || FromDateFilter == undefined || EndDateFilter == '' || EndDateFilter == null || EndDateFilter ==undefined">
                                    <i class="fa fa-file-excel-o "></i>Visit Bulk Update To T2025</button>

                                <button type="button" class="btn btn-sm me-3" (click)="exportCsv()">
                                    <i class="fa fa-file-excel-o "></i>Export</button>
                                <button type="button" class="btn btn-sm me-2" (click)="filterfunction()">Apply
                                </button>
                                <button type="button" class="btn btn-sm" (click)="RefreshFilter()"
                                    style="margin-left: 11px;">Refresh
                                </button>
                            </div>
                        </div>


                    </div>

                    <div class="row mt-3">
                        <div class="col-lg-12 ml-3">
                            <input type="radio" name="allwithoutOverNight" value="withoutOverNight"
                                [(ngModel)]="OvernightFilter" (change)="getVisitListFilter()"> &nbsp; All
                            <input type="radio" class="ms-2" name="allwithoutOverNight" value="withOverNight"
                                [(ngModel)]="OvernightFilter" (change)="getVisitListFilter()"> &nbsp;OverNight

                                <input type="radio" name="Expired" class="ms-5" value="all" [(ngModel)]="evvfilter"
                                (change)="getVisitListFilter()"> &nbsp; All
                            <input type="radio" name="Expired" class="ms-1"  value="exported" [(ngModel)]="evvfilter"
                                (change)="getVisitListFilter()"> &nbsp; Exported
                            <input type="radio" class="ms-1" name="All" value="unexported" [(ngModel)]="evvfilter"
                                (change)="getVisitListFilter()"> &nbsp; Not Exported
                            <!-----Add  delete button 23-11-21--------->

                            <input type="radio" class="ms-5" name="all" value="All"
                                [(ngModel)]="EvvTimesheetApproveFilter" (change)="getVisitListFilter()"> &nbsp; All
                            <input type="radio" class="ms-1" name="all" value="Approve"
                                [(ngModel)]="EvvTimesheetApproveFilter" (change)="getVisitListFilter()"> &nbsp;Approved
                            <input type="radio" class="ms-1" name="all" value="NotApprove"
                                [(ngModel)]="EvvTimesheetApproveFilter" (change)="getVisitListFilter()"> &nbsp; Not
                            Approved

                            <input type="radio" class="ms-1" [(ngModel)]="EvvtimesheetsendBO.isModifiedFilter"
                                name="modifieddatefilter" [value]="true" (change)="getVisitListFilter()">&nbsp;Modified
                            Date
                            <input type="radio" class="ms-1" [value]="false" name="modifieddatefilter"
                                [(ngModel)]="EvvtimesheetsendBO.isModifiedFilter" (change)="getVisitListFilter()">
                            &nbsp;Start Date
                        </div>

                    </div>
                </div>
            </div>
        </div>


        <!-- ejs-grid -->



        <div class="row pl-3 pr-3">
            <!-- <div class="col-lg-12">

            <p class="notealert">Note:End time shows red when visits automatically clockout</p>
        </div> -->
            <div class="col-lg-12 ">
                <section id="tabs" class="project-tab">
                    <!-- <div class="container"> -->
                    <div class="row">
                        <div class="col-lg-12">
                            <nav>
                                <div class="nav nav-tabs nav-fill" id="nav-tab" role="tablist"
                                    (click)="selectTab($event) ">

                                    <a class="nav-item nav-link" id="nav-active-tab" data-bs-toggle="tab"
                                        href="#nav-active" role="tab" aria-controls="nav-profile" aria-selected="false"
                                        (click)="tabchange('Active')"
                                        [ngClass]="{'mytab-inactive':VisitSelectedTab!='Active','active':VisitSelectedTab=='Active'}">Active</a>
                                    <a class="nav-item nav-link" id="nav-active-tab" data-bs-toggle="tab"
                                        href="#nav-archive" role="tab" aria-controls="nav-profile" aria-selected="false"
                                        (click)="tabchange('Archive')"
                                        [ngClass]="{'mytab-inactive':VisitSelectedTab!='Archive','active':VisitSelectedTab=='Archive'}">Archive</a>
                                </div>
                            </nav>
                            <div class="tab-content height" id="nav-tabContent">
                                <div class="tab-pane fade show active" id="nav-active" role="tabpanel"
                                    aria-labelledby="nav-active-tab"
                                    [ngClass]="{'active':VisitSelectedTab=='Active','show':VisitSelectedTab=='Active'}">
                                    <div class="row mb-2 mt-1">
                                        <div class="col-lg-12 ">
                                            <ejs-grid #gridActive id="gridActive" [dataSource]='data | async'
                                                [allowResizing]='true' [allowSorting]='true' [showColumnChooser]='true'
                                                [selectionSettings]='selectionOptions'
                                                (rowDataBound)='rowDataBound($event)' [allowPaging]='true'
                                                [allowFiltering]='true' (dataStateChange)='dataStateChange($event)'
                                                [pageSettings]='initialPage' [filterSettings]='filterOptions'
                                                (actionComplete)="onActionComplete($event)"
                                                (checkBoxChange)="selecToCheck($event)">
                                                <e-columns>
                                                    <!-- checkbox -->
                                                    <e-column type='checkbox' maxWidth=50 [showInColumnChooser]='false'>
                                                    </e-column>
                                                    <!-- evvtimesheet -->
                                                    <e-column field='evvtimesheet' headerText="Actions" [allowFiltering]="false" [allowSorting]="false"
                                                        [showInColumnChooser]='false' textAlign='center'>
                                                        <ng-template #template let-data>
                                                            <button (click)="EditEvvTimesheet(data); iscreate=false"
                                                                class="btn btn-edit-table me-2 Ationsubbtn"
                                                                [disabled]="data.visitProgressStatus=='InProgress' || data.isExported"
                                                                id="enableedit"><i class="fa fa-edit"></i></button>
                                                            <button (click)="deleteList.evvId=data.id"
                                                                class=" btn btn-delete-table me-2"
                                                                [disabled]="data.visitProgressStatus=='InProgress' || data.isExported"
                                                                data-bs-target="#deleteTimesheet"
                                                                data-bs-toggle="modal">
                                                                <i class="fa fa-trash fa-lg"></i></button>
                                                            <button (click)="openActivity(data)"
                                                                class="btn btn-edit-table Ationsubbtn"
                                                                [disabled]="data.validate" *ngIf="fp?.activitiessave"
                                                                id="enableactivityedit"><i
                                                                    class="fa fa-check-circle-o"></i></button>
                                                        </ng-template>
                                                    </e-column>
                                                    <!-- validate -->
                                                    <e-column field='validate' headerText='Validate' [allowFiltering]="false" [allowSorting]="false">
                                                        <ng-template #template let-data>
                                                            <button class="btn btn-sm" data-bs-target="#showerror"
                                                                (click)="errorlst(data)" data-bs-toggle="modal"
                                                                style="background-color: #32dd32;width:65px;"
                                                                *ngIf="data.validate">Ready
                                                            </button>
                                                            <button class="btn btn-sm" data-bs-target="#showerror"
                                                                (click)="errorlst(data)" *ngIf="!data.validate"
                                                                style="background-color:#ff4242;width:65px;"
                                                                data-bs-toggle="modal">
                                                                Validate
                                                            </button>
                                                        </ng-template>
                                                    </e-column>
                                                    <!-- Created Date -->
                                                    <e-column field='createdTime' headerText='Created Date/Time' type="date"
                                                        textAlign='left' [allowFiltering]='false' [format]='datetimeformatoption'>
                                                    </e-column>
                                                    <!-- isApproved -->
                                                    <e-column field='isApproved' headerText="Approved" [allowFiltering]="false" [allowSorting]="false"
                                                        textAlign='center'>
                                                        <ng-template #template let-data>
                                                            <i class="fa fa-check" *ngIf="data.isApproved"
                                                                style="font-size:27px;color:green"></i>
                                                            <!-- <input type="checkbox" [(ngModel)]="data.isApproved" (click)="evvMarkedCheckbox(data)"> -->
                                                        </ng-template>
                                                    </e-column>
                                                    <!-- Notes -->
                                                    <e-column headerText="Notes" type="string" [allowFiltering]="false" [allowSorting]="false">
                                                        <ng-template #template let-data>
                                                            <button
                                                                *ngIf="data.note!=null &&data.note!=undefined && data.note!='' "
                                                                class="btn btn-edit-table text-center"
                                                                data-bs-toggle="modal" data-bs-target="#shownotes"
                                                                (click)="shownotesdescription(data.note)">Notes</button>&nbsp;

                                                        </ng-template>
                                                    </e-column>
                                                    <!-- transactionstatus -->
                                                    <e-column field='transactionStatus' headerText="Transaction Status"
                                                        textAlign='center' [allowFiltering]="false" [allowSorting]="false">
                                                        <ng-template #template let-data>
                                                            <div class="btn btn-Check-table"
                                                                *ngIf="data.transactionstatus=='Success'">
                                                                <i class="fa fa-check-circle"></i>
                                                            </div>
                                                            <div class="btn btn-remove-table"
                                                                *ngIf="data.transactionstatus=='Failed'">
                                                                <i class="fa fa-times-circle-o"></i>
                                                            </div>
                                                        </ng-template>
                                                    </e-column>
                                                    <!-- clientName -->
                                                    <e-column field="clientName" headerText='Client' textAlign='left'
                                                         type='string'>
                                                        <ng-template #filterTemplate let-data>
                                                            <ejs-maskedtextbox placeholder="Enter the value">
                                                            </ejs-maskedtextbox>
                                                        </ng-template>
                                                    </e-column>
                                                    <!-- employeeName -->
                                                    <e-column field="employeeName" headerText="Employee"
                                                        textAlign='left' [allowEditing]='false' type='string'>
                                                        <ng-template #filterTemplate let-data>
                                                            <ejs-maskedtextbox placeholder="Enter the value">
                                                            </ejs-maskedtextbox>
                                                        </ng-template>
                                                    </e-column>

                                                    <!-- <e-column field="scheduleDate"
                                                    headerText="Timesheet Date" textAlign='left'
                                                    [allowEditing]='false' type='date'
                                                    [format]='formatOptions'
                                                    [allowFiltering]="false">

                                                </e-column> -->
                                                    <!-- visitStartTime -->
                                                    <e-column field="visitStartTime" headerText="Start Time" [allowFiltering]="false"
                                                        textAlign='left' type='date' [format]='datetimeformatoption'>
                                                    </e-column>
                                                    <!-- visitEndTime -->
                                                    <e-column field='visitEndTime' headerText='End Time' [allowFiltering]="false"
                                                        textAlign='left' type='date' [format]='datetimeformatoption'>
                                                    </e-column>
                                                    <!-- totalHours -->
                                                    <e-column field='totalHours' headerText='Total hours'
                                                        textAlign='left' type='number'>
                                                    </e-column>

                                                    <!-- isClientSign -->
                                                    <e-column field="isClientSign" headerText="Client Signature" [allowFiltering]="false" [allowSorting]="false"
                                                        textAlign='center' type='string'>
                                                        <ng-template #template let-data>
                                                            <button
                                                                [disabled]="data.clientSignId==null|| data.clientSignId==undefined"
                                                                class="btn btn-sm"
                                                                (click)="getsign(data.clientSignId)">View</button>
                                                        </ng-template>
                                                    </e-column>
                                                    <!-- isEmployeeSign -->
                                                    <e-column field="isEmployeeSign" headerText="Employee Signature" [allowFiltering]="false" [allowSorting]="false"
                                                        textAlign='center' type='string'>
                                                        <ng-template #template let-data>

                                                            <button
                                                                [disabled]="data.employeeSignId==null ||  data.employeeSignId==undefined"
                                                                class="btn btn-sm"
                                                                (click)="getsign(data.employeeSignId)">View</button>
                                                        </ng-template>
                                                    </e-column>
                                                    <!-- masterServiceName -->
                                                    <e-column field="serviceName" headerText='Service Name' textAlign='left'
                                                         type='string'>
                                                        <ng-template #filterTemplate let-data>
                                                            <ejs-maskedtextbox placeholder="Enter the value">
                                                            </ejs-maskedtextbox>
                                                        </ng-template>
                                                    </e-column>
                                                    <!-- Start Location -->
                                                    <e-column field="Start Location" headerText="Start Location" [allowFiltering]="false" [allowSorting]="false"
                                                        textAlign='center' type='string'>
                                                        <ng-template #template let-data>

                                                            <button class="btn btn-edit-table Ationsubbtn"
                                                                [disabled]="data.clockInCallLatitude==0"
                                                                (click)="viewlocation(data.clockInCallLatitude,data.clockInCallLongitude)">View</button>
                                                        </ng-template>
                                                    </e-column>
                                                    <!-- End Location -->
                                                    <e-column field="End Location" headerText="End Location" [allowFiltering]="false" [allowSorting]="false"
                                                        textAlign='center' type='string'>
                                                        <ng-template #template let-data>

                                                            <button class="btn btn-edit-table Ationsubbtn"
                                                                [disabled]="data.clockOutCallLatitude==0"
                                                                (click)="viewlocation(data.clockOutCallLatitude,data.clockOutCallLongitude)">View</button>
                                                        </ng-template>
                                                    </e-column>
                                                    <!-- reasonForModify -->
                                                    <e-column field='reasonForModify' headerText='Reason'
                                                        textAlign='left' type='string' [allowFiltering]="false">
                                                        <ng-template #filterTemplate let-data>
                                                            <ejs-maskedtextbox placeholder="Enter the value">
                                                            </ejs-maskedtextbox>
                                                        </ng-template>
                                                    </e-column>
                                                    <!-- modifiedBy -->
                                                    <e-column field='modifiedBy' headerText='ModifiedBy'
                                                        textAlign='left' type='string'>
                                                        <ng-template #filterTemplate let-data>
                                                            <ejs-maskedtextbox placeholder="Enter the value">
                                                            </ejs-maskedtextbox>
                                                        </ng-template>
                                                    </e-column>
                                                    <e-column field="modiFiedDate" headerText="Modified Date" [allowFiltering]="false"
                                                        textAlign='left' type='date' [format]='formatOptions'>
                                                    </e-column>
                                                    <!-- isExported -->
                                                    <e-column field="isExported" headerText="Exported" type='boolean'>
                                                        <ng-template #filterTemplate let-data>
                                                            <ejs-dropdownlist id='dropdown'
                                                                placeholder='Select Exported State'
                                                                [dataSource]='exportedDropData' [popupHeight]='height'>
                                                            </ejs-dropdownlist>
                                                        </ng-template>
                                                    </e-column>
                                                    <e-column field="isOverNightTs" headerText="OverNight"
                                                        type='boolean'>
                                                        <ng-template #filterTemplate let-data>
                                                            <ejs-dropdownlist id='dropdown'
                                                                placeholder='Select Exported State'
                                                                [dataSource]='exportedDropData' [popupHeight]='height'>
                                                            </ejs-dropdownlist>
                                                        </ng-template>
                                                    </e-column>
                                                    <!-- modifiedBy -->
                                                    <e-column field='visitTypeName' headerText='Visit Type'
                                                        textAlign='left' type='string'>
                                                        <ng-template #filterTemplate let-data>
                                                            <ejs-maskedtextbox placeholder="Enter the value">
                                                            </ejs-maskedtextbox>
                                                        </ng-template>
                                                    </e-column>
                                                    <e-column field="visitProgressStatus" headerText="Visit Status"
                                                        type='string'>
                                                        <ng-template #filterTemplate let-data>
                                                            <ejs-dropdownlist id='dropdown'
                                                                placeholder='Select Exported State' [filterType] = "'Equal'"
                                                                [dataSource]='visitStatusSource' [popupHeight]='height'>
                                                            </ejs-dropdownlist>
                                                        </ng-template>
                                                    </e-column>
                                                    <!--------------------------------table header icon---------------->
                                                    <e-column width="50" [showInColumnChooser]='false' [allowFiltering]="false" [allowSorting]="false">
                                                        <ng-template #headerTemplate let-data>
                                                            <div class="d-none d-lg-block">
                                                                <span id='show' (click)='show()'><i
                                                                        class="fa fa-cog fa-lg" aria-hidden="true">
                                                                    </i></span>
                                                            </div>
                                                        </ng-template>
                                                    </e-column>
                                                </e-columns>
                                                <!-- <e-aggregates>
                                                        <e-aggregate>
                                                            <e-columns>

                                                                <e-column type="Sum" field="totalHours" format="C2">
                                                                    <ng-template #footerTemplate let-data>Total
                                                                        Hours:
                                                                        {{ActivetotalhoursSummaryMinutes}}</ng-template>
                                                                </e-column>

                                                            </e-columns>
                                                        </e-aggregate>
                                                    </e-aggregates> -->
                                            </ejs-grid>
                                        </div>
                                        <div class="col-lg-12">
                                            <div *ngIf="SelectAllIdList.length == 0" class="text-center"
                                                style="color:red">
                                                <p>No data available</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!--------------------------------------------------archive view------------------------------------------------------------>
                                <div class="tab-pane fade" id="nav-archive" role="tabpanel"
                                    aria-labelledby="nav-archive-tab"
                                    [ngClass]="{'active':VisitSelectedTab=='Archive','show':VisitSelectedTab=='Archive'}">
                                    <div class="row  p-2">
                                        <div class="col-lg-12">
                                            <ejs-grid #gridArchive id="gridArchive" [dataSource]='dataarchive | async'
                                                [allowResizing]='true' [allowSorting]='true'
                                                (rowDataBound)='rowDataBound($event)'
                                                [selectionSettings]='selectionOptions' [allowPaging]='true'
                                                [allowFiltering]='true' [showColumnChooser]='true'
                                                (dataStateChange)='dataStateChangeArchive($event)'
                                                [pageSettings]='initialPage' [filterSettings]='filterOptions'
                                                (checkBoxChange)="selecToCheck($event)">
                                                <e-columns>
                                                    <!-- checkbox -->
                                                    <e-column type='checkbox' maxWidth=50 [showInColumnChooser]='false'>
                                                    </e-column>
                                                    <!-- evvtimesheet -->
                                                    <e-column field='evvtimesheet' headerText="Actions" [allowFiltering]="false" [allowSorting]="false"
                                                        [showInColumnChooser]='false' textAlign='center'>
                                                        <ng-template #template let-data>
                                                            <button (click)="EditEvvTimesheet(data); iscreate=false"
                                                                class="btn btn-edit-table me-2 Ationsubbtn"
                                                                [disabled]="data.visitProgressStatus=='InProgress' || data.isExported"
                                                                id="enableedit"><i class="fa fa-edit"></i></button>
                                                            <button (click)="deleteList.evvId=data.id"
                                                                class=" btn btn-delete-table ms-1"
                                                                [disabled]="data.isExported"
                                                                data-bs-target="#deleteTimesheet"
                                                                data-bs-toggle="modal">
                                                                <i class="fa fa-trash fa-lg"></i></button>
                                                        </ng-template>
                                                    </e-column>
                                                    <!-- validate -->
                                                    <e-column field='validate' headerText='Validate' [allowFiltering]="false" [allowSorting]="false">
                                                        <ng-template #template let-data>
                                                            <button class="btn btn-sm" data-bs-target="#showerror"
                                                                (click)="errorlst(data)" data-bs-toggle="modal"
                                                                style="background-color: #32dd32;width:65px;"
                                                                *ngIf="data.validate">Ready
                                                            </button>
                                                            <button class="btn btn-sm" data-bs-target="#showerror"
                                                                (click)="errorlst(data)" *ngIf="!data.validate"
                                                                style="background-color:#ff4242;width:65px;"
                                                                data-bs-toggle="modal">
                                                                Validate
                                                            </button>
                                                        </ng-template>
                                                    </e-column>
                                                    <!-- Created Date -->
                                                    <e-column field='createdTime' headerText='Created Date/Time' type="date"
                                                        textAlign='left' [allowFiltering]='false' [allowEditing]="false" [format]='datetimeformatoption'>
                                                    </e-column>
                                                    <!-- isApproved -->
                                                    <e-column field='isApproved' headerText="Approved" [allowFiltering]="false" [allowSorting]="false"
                                                        textAlign='center'>
                                                        <ng-template #template let-data>
                                                            <i class="fa fa-check" *ngIf="data.isApproved"
                                                                style="font-size:27px;color:green"></i>
                                                            <!-- <input type="checkbox" [(ngModel)]="data.isApproved" (click)="evvMarkedCheckbox(data)"> -->
                                                        </ng-template>
                                                    </e-column>
                                                    <!-- Notes -->
                                                    <e-column headerText="Notes" [allowFiltering]="false" [allowSorting]="false" type="string">
                                                        <ng-template #template let-data>
                                                            <button
                                                                *ngIf="data.note!=null &&data.note!=undefined && data.note!='' "
                                                                class="btn btn-edit-table text-center"
                                                                data-bs-toggle="modal" data-target="#shownotes"
                                                                (click)="shownotesdescription(data.note)">Notes</button>&nbsp;

                                                        </ng-template>
                                                    </e-column>
                                                    <!-- transactionstatus -->
                                                    <e-column field='transactionStatus' headerText="Transaction Status" [allowFiltering]="false" [allowSorting]="false"
                                                        textAlign='center'>
                                                        <ng-template #template let-data>
                                                            <div class="btn btn-Check-table"
                                                                *ngIf="data.transactionstatus=='Success'">
                                                                <i class="fa fa-check-circle"></i>
                                                            </div>
                                                            <div class="btn btn-remove-table"
                                                                *ngIf="data.transactionstatus=='Failed'">
                                                                <i class="fa fa-times-circle-o"></i>
                                                            </div>
                                                        </ng-template>
                                                    </e-column>
                                                    <!-- clientName -->
                                                    <e-column field="clientName" headerText='Client' textAlign='left'
                                                        type='string'>
                                                        <ng-template #filterTemplate let-data>
                                                            <ejs-maskedtextbox placeholder="Enter the value">
                                                            </ejs-maskedtextbox>
                                                        </ng-template>
                                                    </e-column>
                                                    <!-- employeeName -->
                                                    <e-column field="employeeName" headerText="Employee"
                                                        textAlign='left' type='string'>
                                                        <ng-template #filterTemplate let-data>
                                                            <ejs-maskedtextbox placeholder="Enter the value">
                                                            </ejs-maskedtextbox>
                                                        </ng-template>
                                                    </e-column>

                                                    <!-- <e-column field="scheduleDate"
                                                    headerText="Timesheet Date" textAlign='left'
                                                    [allowEditing]='false' type='date'
                                                    [format]='formatOptions'
                                                    [allowFiltering]="false">

                                                </e-column> -->
                                                    <!-- visitStartTime -->
                                                    <e-column field="visitStartTime" headerText="Start Time" [allowFiltering]="false"
                                                        textAlign='left' type='date' [format]='datetimeformatoption'>
                                                    </e-column>
                                                    <!-- visitEndTime -->
                                                    <e-column field='visitEndTime' headerText='End Time' [allowFiltering]="false"
                                                        textAlign='left' type='date' [format]='datetimeformatoption'>
                                                    </e-column>
                                                    <!-- totalHours -->
                                                    <e-column field='totalHours' headerText='Total hours'
                                                        textAlign='left' type='number'>
                                                    </e-column>

                                                    <!-- isClientSign -->
                                                    <e-column field="isClientSign" headerText="Client Signature" [allowFiltering]="false" [allowSorting]="false"
                                                        textAlign='center' type='string'>
                                                        <ng-template #template let-data>
                                                            <button
                                                                [disabled]="data.clientSignId==null|| data.clientSignId==undefined"
                                                                class="btn btn-sm"
                                                                (click)="getsign(data.clientSignId)">View</button>
                                                        </ng-template>
                                                    </e-column>
                                                    <!-- isEmployeeSign -->
                                                    <e-column field="isEmployeeSign" headerText="Employee Signature" [allowFiltering]="false" [allowSorting]="false"
                                                        textAlign='center' type='string'>
                                                        <ng-template #template let-data>

                                                            <button
                                                                [disabled]="data.employeeSignId==null ||  data.employeeSignId==undefined"
                                                                class="btn btn-sm"
                                                                (click)="getsign(data.employeeSignId)">View</button>
                                                        </ng-template>
                                                    </e-column>
                                                    <!-- masterServiceName -->
                                                    <e-column field="serviceName" headerText='Service Name' textAlign='left'
                                                         type='string'>
                                                        <ng-template #filterTemplate let-data>
                                                            <ejs-maskedtextbox placeholder="Enter the value">
                                                            </ejs-maskedtextbox>
                                                        </ng-template>
                                                    </e-column>                                                    <!-- Start Location -->
                                                    <e-column field="Start Location" headerText="Start Location" [allowFiltering]="false" [allowSorting]="false"
                                                        textAlign='center' type='string'>
                                                        <ng-template #template let-data>

                                                            <button class="btn btn-edit-table Ationsubbtn"
                                                                (click)="viewlocation(data.clockInCallLatitude,data.clockInCallLongitude)">View</button>
                                                        </ng-template>
                                                    </e-column>
                                                    <!-- End Location -->
                                                    <e-column field="End Location" headerText="End Location" [allowFiltering]="false" [allowSorting]="false"
                                                        textAlign='center' type='string'>
                                                        <ng-template #template let-data>

                                                            <button class="btn btn-edit-table Ationsubbtn"
                                                                (click)="viewlocation(data.clockOutCallLatitude,data.clockOutCallLongitude)">View</button>
                                                        </ng-template>
                                                    </e-column>
                                                    <!-- reasonForModify -->
                                                    <e-column field='reasonForModify' headerText='Reason'
                                                        textAlign='left' type='string' [allowFiltering]="false">
                                                        <ng-template #filterTemplate let-data>
                                                            <ejs-maskedtextbox placeholder="Enter the value">
                                                            </ejs-maskedtextbox>
                                                        </ng-template>
                                                    </e-column>
                                                    <!-- modifiedBy -->
                                                    <e-column field='modifiedBy' headerText='ModifiedBy'
                                                        textAlign='left' type='string'>
                                                        <ng-template #filterTemplate let-data>
                                                            <ejs-maskedtextbox placeholder="Enter the value">
                                                            </ejs-maskedtextbox>
                                                        </ng-template>
                                                    </e-column>
                                                    <e-column field="modiFiedDate" headerText="Modified Date" type="date"
                                                        textAlign='left' [allowFiltering]='false' [allowEditing]="false" [format]='formatOptions'>
                                                    </e-column>
                                                    <!-- isExported -->
                                                    <e-column minWidth=100 field="isExported" headerText="Exported"
                                                        type='boolean'>
                                                        <ng-template #filterTemplate let-data>
                                                            <ejs-dropdownlist id='dropdown'
                                                                placeholder='Select Exported State'
                                                                [dataSource]='exportedDropData' [popupHeight]='height'>
                                                            </ejs-dropdownlist>
                                                        </ng-template>
                                                    </e-column>
                                                    <e-column minWidth=100 field="isOverNightTs" headerText="OverNight"
                                                        type='boolean'>
                                                        <ng-template #filterTemplate let-data>
                                                            <ejs-dropdownlist id='dropdown'
                                                                placeholder='Select Exported State'
                                                                [dataSource]='exportedDropData' [popupHeight]='height'>
                                                            </ejs-dropdownlist>
                                                        </ng-template>
                                                    </e-column>
                                                    <!-- modifiedBy -->
                                                    <e-column field='visitTypeName' headerText='Visit Type'
                                                        textAlign='left' type='string'>
                                                        <ng-template #filterTemplate let-data>
                                                            <ejs-maskedtextbox placeholder="Enter the value">
                                                            </ejs-maskedtextbox>
                                                        </ng-template>
                                                    </e-column>
                                                    <e-column minWidth=100 field="visitProgressStatus"
                                                        headerText="Visit Status" type='string'>
                                                        <ng-template #filterTemplate let-data>
                                                            <ejs-dropdownlist id='dropdown'
                                                                placeholder='Select Exported State'
                                                                [dataSource]='visitStatusSource' [popupHeight]='height'>
                                                            </ejs-dropdownlist>
                                                        </ng-template>
                                                    </e-column>
                                                    <!--------------------------------table header icon---------------->
                                                    <e-column width="50" [showInColumnChooser]='false' [allowFiltering]="false" [allowSorting]="false">
                                                        <ng-template #headerTemplate let-data>
                                                            <div class="d-none d-lg-block">
                                                                <span id='showarchive' (click)='showarchive()'><i
                                                                        class="fa fa-cog fa-lg" aria-hidden="true">
                                                                    </i></span>
                                                            </div>
                                                        </ng-template>
                                                    </e-column>
                                                </e-columns>
                                                <!-- 
                                                    <e-aggregates>
                                                        <e-aggregate>
                                                            <e-columns>

                                                                <e-column type="Sum" field="totalHours" format="C2">
                                                                    <ng-template #footerTemplate let-data>Total
                                                                        Hours:
                                                                        {{ArchivetotalhoursSummaryMinutes}}</ng-template>
                                                                </e-column>

                                                            </e-columns>
                                                        </e-aggregate>
                                                    </e-aggregates> -->
                                            </ejs-grid>

                                        </div>
                                        <div class="col-lg-12">
                                            <div *ngIf="SelectAllIdList.length == 0" class="text-center"
                                                style="color:red">
                                                <p>No data available</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </div>
</div>



<!--==========================================show Error List ==========================================================-->
<span id="OpenModal2" data-bs-target="#showerror" data-bs-toggle="modal"></span>
<div class="modal fade" id="showerror" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">

    <div class="modal-dialog " role="document">
        <div class="modal-content">
            <div class="modal-header">
                <label class="font-header">Check Validation Status</label>
                <button class="btn blue-btn btn-sm" type="button" data-bs-dismiss="modal">Close</button>
            </div>
            <div class="modal-body">
                <div class="container scrolltbody">

                    <div>
                        <table class="table table-responsive table-hover table-bordered" style="margin-left: 0px">
                            <thead>
                                <!-- <tr> -->
                                <th style="background: #502189;width: 255px;color: white;" class="pointer">
                                    Column</th>
                                <th style="background:#502189;width: 150px;color: white;" class="pointer">Status
                                </th>
                                <!-- </tr> -->
                            </thead>
                            <tbody>
                                <!-- paginate:{ id:'employee', itemsPerPage: 10, currentPage: p ,totalItems:showerrolist.length };let i=index  -->
                                <tr *ngFor="let c of showerrolist" class="row1">

                                    <!--  -->

                                    <!-- <td   [style.color]="c.color" class="row1 font-weight"  >{{c.columnName}}</td> -->
                                    <td [style.color]="c.valid=='Valid'?'GREEN':'RED'">{{c.name}}</td>
                                    <td [style.color]="c.valid=='Valid'?'BLACK':'RED'">{{c.valid}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Notes -->

<!--==========================================show Error List ==========================================================-->
<span id="OpenNotesModal" data-bs-target="#shownotes" data-bs-toggle="modal"></span>
<div class="modal fade" id="shownotes" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">

    <div class="modal-dialog " role="document">
        <div class="modal-content">
            <div class="modal-header">
                <label class="font-header">Notes</label>

                <button type="button" class="btn-close" data-bs-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
                <div class="container scrolltbody">
                    <div class="col-lg-12">
                        <textarea class="form-control" style="max-width: 430px;height: 72px;"
                            [(ngModel)]="evvtimesheetnotes" disabled>
                        </textarea>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!--==========================================delete individual timesheet--==========================================-->
<span data-bs-target="#deleteTimesheet" data-bs-toggle="modal" id="deleteTimes"></span>
<div class="modal fade " id="deleteTimesheet" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog " role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">Delete Timesheet</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal">&times;</button>

            </div>
            <div class="alert alert-warning alert-dismissible fade show" *ngIf="saveErr!=''" role="alert">
                <p>{{saveErr}}</p>
                <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close" (click)="saveErr=''">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <form [formGroup]="resetPass">

                    <div class="row">
                        <div class="col-lg-2">
                            <label style="font-weight: 600;margin-top:6px;">Password<sup style="color:red; font-size: 1.35em;
                          top: 0em;">&nbsp;*</sup></label>
                        </div>
                        <div class="col-lg-5">
                            <input type="password" class="form-control" formControlName="Password"
                                (ngModelChange)="ClearErrmsg()" [(ngModel)]="deleteList.admin_Password"
                                (keyup)="passvalid($event)">
                            <div *ngIf="resetPass.controls['Password'].invalid && (resetPass.controls['Password'].dirty || resetPass.controls['Password'].touched) "
                                class="alert alert-danger" style="height: 30px; margin-top: 10px;">
                                <div *ngIf="resetPass.controls['Password'].errors.required">
                                    Password is required.
                                </div>
                            </div>
                            <div *ngIf="passerror && resetPass.controls['Password'].valid  " class="alert alert-danger">
                                <div>
                                    Enter Valid Password
                                </div>

                            </div>
                        </div>

                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <label class="passwordnote mt-5"><i>Note:&nbsp;Password should
                                    contain atleast 8
                                    characters/
                                    digits includes 1 special character, 1 lower and uppercase characters
                                </i></label>
                        </div>
                    </div>
                </form>

            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-sm" [disabled]="!resetPass.valid ||passerror || IsButtonDisable"
                    (click)="deleteEvvTimesheet()">Delete</button>
                <button type="button" class="btn btn-sm" data-bs-dismiss="modal" data-bs-target="#modal"
                    (click)="CancelDelete()">Cancel</button>
            </div>
        </div>
    </div>
</div>




<span data-bs-target="#updateTimesheet" data-bs-toggle="modal" id="update"></span>
<div class="modal fade " id="updateTimesheet" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">

                <h5 *ngIf="edittimesheetid!='00000000-0000-0000-0000-000000000000'" class="modal-title font-header"
                    id="exampleModalLabel">Update Evv
                    Timesheet</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal">&times;</button>
            </div>
            <div class="alert alert-warning alert-dismissible fade show" *ngIf="saveEvvErr!=''" role="alert">
                <p>{{saveEvvErr}}</p>
                <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"
                    (click)="saveEvvErr=''">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="col-lg-12">
                            <label class="manualentry-label mr-0 ml-3">Employee
                                Name <span class="super-script">*</span></label>
                        </div>
                        <div class="col-lg-12">
                            <input type="text" *ngIf="!iscreate" class="form-control" [(ngModel)]="editEmployee"
                                [disabled]="true">

                        </div>

                    </div>
                    <div class="col-lg-6">
                        <div class="col-lg-12">
                            <label class="manualentry-label mr-0 ml-3">Client
                                Name <span class="super-script">*</span></label>
                        </div>
                        <div class="col-lg-12">
                            <input type="text" class="form-control" [(ngModel)]="editClient" *ngIf="!iscreate"
                                [disabled]="true">



                        </div>
                    </div>

                </div>
                <div class="row">
                    <div class="col-lg-6">
                        <div class="col-lg-12">
                            <label class="manualentry-label mr-0 ml-3">Start Date
                                <span class="super-script">*</span></label>
                        </div>
                        <div class="col-lg-12">
                            <input type="datetime-local" class="form-control w-100" [(ngModel)]="editstart"
                                [max]="startmin"
                                (ngModelChange)="hourscal(); checkStartDate();getActiveAuthorization()" />


                        </div>

                    </div>
                    <div class="col-lg-6">
                        <div class="col-lg-12">
                            <label class="manualentry-label mr-0 ml-3">End Date
                                <span class="super-script">*</span></label>
                        </div>
                        <div class="col-lg-12">
                            <input type="datetime-local" class="form-control w-100" [(ngModel)]="editend"
                                [max]="startmin" (ngModelChange)="hourscal();getActiveAuthorization()" />

                        </div>
                    </div>

                </div>

                <div class="row">
                    <div class="col-lg-6">
                        <div class="col-lg-12">
                            <label class="manualentry-label mr-0 ml-3">Service <span
                                    class="super-script">*</span></label>
                        </div>
                        <div class="col-lg-12">
                            <input type="text" class="form-control" [(ngModel)]="editservice" [disabled]="true"
                                *ngIf="!iscreate">



                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="col-lg-12">
                            <label class="manualentry-label mr-0 ml-3">Work
                                Hour</label>
                        </div>
                        <div class="col-lg-12">

                            <input type="text" class="form-control" [(ngModel)]="edittime" [disabled]="true">


                        </div>
                    </div>



                </div>
                <div class="row mb-1" *ngIf="!iscreate">
                    <div class="col-lg-6">
                        <div class="col-lg-12">
                            <label class="manualentry-label mr-0 ml-3">Reason <span
                                    class="super-script">*</span></label>
                        </div>
                        <div class="col-lg-12">
                            <input type="text" class="form-control" [(ngModel)]="editreason">

                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="col-lg-12">
                            <label class="manualentry-label mr-0 ml-3">Notes</label>
                        </div>
                        <div class="col-lg-12">
                            <input type="text" class="form-control" [(ngModel)]="editNotes">

                        </div>
                    </div>
                </div>
                <div class="row" *ngIf="ActiveAuthorizationList?.length > 0">
                    <div class="col-lg-12">
                        <ejs-grid #gridActiveAuthorization [dataSource]='ActiveAuthorizationList' [rowHeight]='40'
                            [pageSettings]='AuthorizationinitialPage' [allowPaging]='true'
                            (rowSelected)='rowSelected($event)' [allowResizing]='true'>
                            <e-columns>
                                <!-- startdate -->
                                <e-column field="startDate" headerText="Start Date" minWidth=120
                                    [format]='formatOptions' type="date">
                                    <ng-template #filterTemplate let-row>
                                    </ng-template>
                                </e-column>
                                <!-- enddate -->
                                <e-column field="endDate" headerText="End Date" minWidth=120 [format]='formatOptions'
                                    type="date">
                                    <ng-template #filterTemplate let-row>
                                    </ng-template>
                                </e-column>
                                <!-- Service -->
                                <e-column minWidth=100 field="serviceCodeName" headerText="Service">
                                    <ng-template #filterTemplate let-row>
                                    </ng-template>
                                </e-column>
                                <e-column minWidth=100 field="authNote" headerText="AuthNote">
                                    <ng-template #filterTemplate let-row>
                                    </ng-template>
                                </e-column>

                                <e-column minWidth=100 field="serviceGroup" headerText="Service Group">
                                    <ng-template #filterTemplate let-row>
                                    </ng-template>
                                </e-column>



                                <!-- BalanceAmount -->
                                <e-column field="balanceAmount" headerText="Remaining Amount" minWidth=120 type="number">
                                    <!-- <ng-template #filterTemplate let-row>
                                    </ng-template> -->
                                </e-column>


                                <!-- Payor -->
                                <e-column field="payor" headerText="Payor" minWidth=120>
                                    <ng-template #filterTemplate let-row>
                                    </ng-template>
                                </e-column>
                                <!-- Rate -->
                                <e-column minWidth=100 field="rate" headerText="Rate" type="number">
                                    <!-- <ng-template #filterTemplate let-row>
                                    </ng-template> -->
                                </e-column>
                                <e-column minWidth=100 field="insuranceNumber" headerText="InsuranceNumber">
                                    <ng-template #filterTemplate let-row>
                                    </ng-template>
                                </e-column>

                            </e-columns>
                        </ejs-grid>
                    </div>
                </div>
            </div>


            <div class="modal-footer">
                <div class="row w-100">
                    <div class="col-lg-7">
                        <!-- <p class="notealert ms-0" >Note: Start Time ,End Time & Note field only
                            editable and Start Date can not be Changed</p> -->
                    </div>
                    <div class="col-lg-5 text-end">
                        <button class="btn btn-sm" (click)="updateEvvTimesheet()"
                            [disabled]="IsButtonDisable || editreason==''||editreason==null||editreason==undefined || authId == null || authId == undefined || authId =='' || authId == '00000000-0000-0000-0000-000000000000'">
                            Update & Close
                        </button>&nbsp;&nbsp;&nbsp;

                        <button class="btn blue-btn btn-sm ml-2" data-bs-dismiss="modal" data-bs-target="#modal">
                            Close
                        </button>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>


<span data-bs-target="#Openactivitiesmodal" data-bs-toggle="modal" id="activities" data-bs-toggle="modal"></span>
<div class="modal fade" id="Openactivitiesmodal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">

    <div class="modal-dialog " role="document">
        <div class="modal-content modal-dialog" style="height: 350px;">
            <div class="modal-header">
                <label class="font-header">Activities</label>

                <button type="button" class="btn-close" data-bs-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-8" *ngFor="let act of acttivitieslist;let index = index">
                        <td>
                            <P style="display:inline-block;"><input type="checkbox" class="ms-2"
                                    [checked]="act.isSelected" disabled><label class="ms-3">{{act.activityName}}</label>
                            </P>
                        </td>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>



<!--------------------- signature-------------- -->
<span data-bs-target="#viewsignnatureclient" data-bs-toggle="modal" id="viewsignclient"></span>
<div class="modal fade " id="viewsignnatureclient" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog " role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">View Signature</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="clearsign()">&times;</button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-12">
                        <img [src]="imgrulclient" style="height: 100%;width: 100%;text-align: center;">
                    </div>
                </div>
            </div>
            <div class="modal-footer">

                <button type="button" class="btn btn-sm" data-bs-dismiss="modal" (click)="clearsign()"
                    data-bs-target="#modal">Cancel</button>
            </div>
        </div>
    </div>
</div>

<span data-bs-target="#viewsignnatureemployee" data-bs-toggle="modal" id="viewsignemployee"></span>
<div class="modal fade " id="viewsignnatureemployee" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog " role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">View Signature</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
                <img [src]="imgrulemployee">
            </div>
            <div class="modal-footer">

                <button type="button" class="btn btn-sm" data-bs-dismiss="modal" data-bs-target="#modal">Cancel</button>
            </div>
        </div>
    </div>
</div>

<!------------------------------------------------- Delete Multiple timesheet------------------------------------------------------>
<span data-bs-target="#deleteMultiTimesheet" data-bs-toggle="modal" id="Multidelete"></span>
<div class="modal fade" id="deleteMultiTimesheet" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">
                    Delete Timesheet
                </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal">
                </button>
            </div>
            <div class="alert alert-warning alert-dismissible fade show" *ngIf="saveErr != ''" role="alert">
                <p>{{ saveErr }}</p>
                <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"
                    (click)="saveErr = ''">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <form [formGroup]="resetPassMulti">
                    <div class="row">
                        <div class="col-lg-2">
                            <label style="font-weight: 600; margin-top: 6px">Password<sup
                                    style="color: red; font-size: 1.35em; top: 0em">&nbsp;*</sup></label>
                        </div>
                        <div class="col-lg-5">
                            <input type="password" class="form-control" formControlName="Password"
                                (ngModelChange)="ClearErrmsg()" [(ngModel)]="multipleDelete.admin_Password"
                                (keyup)="passvalid($event)" />
                            <div *ngIf="
                  resetPassMulti.controls['Password'].invalid &&
                  (resetPassMulti.controls['Password'].dirty ||
                    resetPassMulti.controls['Password'].touched)
                " class="alert alert-danger" style="height: 30px; margin-top: 10px">
                                <div *ngIf="resetPassMulti.controls['Password'].errors.required">
                                    Password is required.
                                </div>
                            </div>
                            <div *ngIf="passerror && resetPassMulti.controls['Password'].valid"
                                class="alert alert-danger">
                                <div>Enter Valid Password</div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <label class="passwordnote mt-5"><i>Note:&nbsp;Password should contain atleast 8
                                    characters/
                                    digits includes 1 special character, 1 lower and uppercase
                                    characters
                                </i></label>
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-sm" [disabled]="!resetPassMulti.valid || passerror"
                    (click)="deleteMultipleTimesheet()">
                    Delete
                </button>
                <button type="button" class="btn btn-sm" data-bs-dismiss="modal" data-bs-target="#modal"
                    (click)="cancelMultiDelete()">
                    Cancel
                </button>
            </div>
        </div>
    </div>
</div>

<!-- .....................................ReCalculate-Rate............................................................. -->
<!-- <span id="UpdateRatetimesheet" data-bs-target="#UpdateRatetimesheet1" data-bs-toggle="modal"></span>
        <div class="modal fade " id="UpdateRatetimesheet1" tabindex="-1" role="dialog"
            aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
            <div class="modal-dialog modal-md " role="document">
                <div class="modal-content">

                    <div class="modal-header">
                        <h5 class="modal-title font-header" id="exampleModalLabel">Re-Calculate Rate</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true"></span>
                        </button>
                    </div>
                    <div class="modal-body">


                        <div class="row">
                            <div class="col-lg-5">

                                <label>StartDate<sup class="super-script">*</sup>
                                </label>
                            </div>


                            <div class="col-lg-7">
                                <my-date-picker [options]="myDatePickerOptions" placeholder="mm/dd/yyyy"
                                    [selDate]="startDate"
                                    (inputFieldChanged)="DateFormat($event,'inputchanged','StartDate')"
                                    (dateChanged)="DateFormat($event,'datechanged','StartDate')">
                                </my-date-picker>
                            </div>

                        </div>

                        <div class="row">
                            <div class="col-lg-5 ">
                                <label>EndDate<sup class="super-script">*</sup>
                                </label>
                            </div>

                            <div class="col-lg-7">
                                <my-date-picker [options]="myDatePickerOptions" placeholder="mm/dd/yyyy"
                                    [selDate]="endDate"
                                    (inputFieldChanged)="DateFormat($event,'inputchanged','EndDate')"
                                    (dateChanged)="DateFormat($event,'datechanged','EndDate')">
                                </my-date-picker>
                            </div>

                        </div>


                    </div>


                    <div class="modal-footer">
                        <button type="button" class="btn btn-sm" [disabled]="(startDate==''||startDate==undefined||
                endDate==''||endDate==undefined)" (click)=" UpdateRateTimesheet()">Update</button>
                        <button type="button" class="btn btn-sm" data-bs-dismiss="modal">Close</button>
                    </div>



                </div>



            </div> -->


<span id="updateauthevv" data-bs-target="#BulkUpdateevv" data-bs-toggle="modal"></span>
<div class="modal fade" id="BulkUpdateevv" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">

    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <label class="font-header">Visits Bulk Update</label>

                <button type="button" class="btn-close" data-bs-dismiss="modal"
                    (click)="closeBulkUpdate()">&times;</button>
            </div>
            <div class="modal-body">
                <span *ngIf="UpdateAuthorizationList?.length == 0 && IsBulkUpdate">No Authorization found</span>
                <div class="row" *ngIf="UpdateAuthorizationList?.length > 0">
                    <div class="col-lg-12">

                        <ejs-grid [dataSource]='UpdateAuthorizationList' [rowHeight]='40'
                            [pageSettings]='UpdateAuthorizationinitialPage' [allowPaging]='true'
                            (queryCellInfo)='customiseCell($event)'
                            (rowSelected)='rowSelectedForBulkVisitUpdate($event)' [allowResizing]='true'>
                            <e-columns>
                                <!-- startdate -->
                                <e-column field="startDate" headerText="Start Date" minWidth=120
                                    [format]='formatOptions' type="date">
                                    <ng-template #filterTemplate let-row>
                                    </ng-template>
                                </e-column>
                                <!-- enddate -->
                                <e-column field="endDate" headerText="End Date" minWidth=120 [format]='formatOptions'
                                    type="date">
                                    <ng-template #filterTemplate let-row>
                                    </ng-template>
                                </e-column>
                                <!-- Service -->
                                <e-column minWidth=100 field="serviceCodeName" headerText="Service" minWidth=200>
                                    <ng-template #filterTemplate let-row>
                                    </ng-template>
                                </e-column>
                                <e-column minWidth=100 field="authNote" headerText="AuthNote">
                                    <ng-template #filterTemplate let-row>
                                    </ng-template>
                                </e-column>

                                <e-column minWidth=100 field="serviceGroup" headerText="Service Group">
                                    <ng-template #filterTemplate let-row>
                                    </ng-template>
                                </e-column>



                                <!-- BalanceAmount -->
                                <e-column field="balanceAmount" headerText="Remaining Amount" minWidth=120>
                                    <ng-template #filterTemplate let-row>
                                    </ng-template>
                                </e-column>


                                <!-- Payor -->
                                <e-column field="payor" headerText="Payor" minWidth=120>
                                    <ng-template #filterTemplate let-row>
                                    </ng-template>
                                </e-column>
                                <!-- Rate -->
                                <e-column minWidth=100 field="rate" headerText="Rate">
                                    <ng-template #filterTemplate let-row>
                                    </ng-template>
                                </e-column>
                                <e-column minWidth=100 field="insuranceNumber" headerText="InsuranceNumber">
                                    <!-- <ng-template #filterTemplate let-row>
                                    </ng-template> -->
                                </e-column>

                            </e-columns>
                        </ejs-grid>
                    </div>
                </div>
            </div>
            <div class="modal-footer mt-3">
                <button type="button" class="btn btn-sm" *ngIf="UpdateAuthorizationList?.length > 0"
                    [disabled]="IsButtonDisable || bulkUpdateAuthId == '' || bulkUpdateAuthId == null || bulkUpdateAuthId == undefined || bulkUpdateAuthId == '00000000-0000-0000-0000-000000000000'"
                    (click)="updatebulkvisits()">Update & Close</button>
                <button *ngIf="UpdateAuthorizationList?.length == 0" type="button" class="btn btn-sm"
                    data-bs-dismiss="modal" (click)="closeBulkUpdate()">Close</button>

            </div>
        </div>
    </div>
</div>

<span id="activitymodal" data-bs-toggle="modal" data-bs-target="#saveactivitymodal"></span>
<div class="modal fade " id="saveactivitymodal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-sm">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" style="color: #502189;"><b>Save Activities</b></h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                    (click)="closeerror()"></button>
            </div>
            <div class="modal-body mt-3">
                <div *ngFor="let act of Activities">
                    <input type="checkbox" [(ngModel)]="act.isSelected"> &nbsp; {{act.activityName}}
                </div>
            </div>
            <div class="modal-footer mt-3">
                <button type="button" class="btn btn-sm" [disabled]="IsButtonDisable" (click)="saveActivity()">Save &
                    Close</button>
                <button type="button" class="btn btn-sm" data-bs-dismiss="modal">Close</button>

            </div>
        </div>
    </div>
</div>

<span id="errorpopup1" data-bs-toggle="modal" data-bs-target="#errormodal1"></span>
<div class="modal fade modalbackgrod" id="errormodal1" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" style="color: #502189;"><b>Error Status</b></h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                    (click)="closeerror()"></button>
            </div>
            <div class="modal-body mt-3">
                <div *ngFor="let items of errorlist">
                    <b class="text-danger">"{{items}}"</b>
                </div>
            </div>
            <div class="modal-footer mt-3">
                <button type="button" class="btn btn-sm" data-bs-dismiss="modal" (click)="closeerror()">Close</button>

            </div>
        </div>
    </div>
</div>